(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wuyin-card-hover"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wuyin-card-hover')) {
  customElements.define('wuyin-card-hover', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
      const signal = this.controller.signal;
      const link = this.closest('a');
      const card = this.closest('.wyhp-product,.wyc-card,.ProductItem') || link;
      const media = this.parentElement;
      media?.addEventListener('pointerdown', event => {
        if (!event.isPrimary || !['touch', 'pen'].includes(event.pointerType)) return;
        this.touchStart = {x: event.clientX, y: event.clientY, id: event.pointerId};
        this.setAttribute('data-touch-active', '');
        this.loadImage();
      }, {signal, passive: true});
      media?.addEventListener('pointermove', event => {
        if (!this.touchStart || event.pointerId !== this.touchStart.id) return;
        if (Math.hypot(event.clientX - this.touchStart.x, event.clientY - this.touchStart.y) > 12) this.resetTouch();
      }, {signal, passive: true});
      ['pointerleave', 'lostpointercapture'].forEach(type => {
        media?.addEventListener(type, () => this.resetTouch(), {signal, passive: true});
      });
      ['pointerup', 'pointercancel'].forEach(type => {
        window.addEventListener(type, event => {
          if (this.touchStart?.id === event.pointerId) this.resetTouch();
        }, {signal, passive: true, capture: true});
      });
      document.addEventListener('scroll', () => {
        if (this.touchStart) this.resetTouch();
      }, {signal, passive: true, capture: true});
      link?.addEventListener('pointerenter', () => this.loadImage(), {signal});
      card?.addEventListener('focusin', () => this.loadImage(), {signal});
      this.hoverMedia.addEventListener('change', () => this.watchImage(), {signal});
      this.watchImage();
    }
    resetTouch() {
      this.touchStart = null;
      this.removeAttribute('data-touch-active');
    }
    watchImage() {
      this.observer?.disconnect();
      if (this.dataset.requested) return;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting) && this.loadImage()) this.observer.disconnect();
        }, {rootMargin: '160px 0px'});
        this.observer.observe(this);
      }
    }
    loadImage() {
      if (this.dataset.requested) return false;
      const template = this.querySelector('template');
      if (!template) return false;
      const fragment = template.content.cloneNode(true);
      const image = fragment.querySelector('img');
      if (!image) return false;
      this.dataset.requested = 'true';
      const ready = () => {
        if (image.naturalWidth > 0) this.setAttribute('data-ready', '');
      };
      image.addEventListener('load', ready, {once: true});
      image.addEventListener('error', () => {
        image.remove();
        delete this.dataset.requested;
        this.removeAttribute('data-ready');
        this.resetTouch();
      }, {once: true});
      this.append(fragment);
      if (image.complete) ready();
      return true;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resetTouch();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wuyin-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wuyin-navigation')) {
    customElements.define('wuyin-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.disclosures = Array.from(this.querySelectorAll('.WuyinNav__Disclosure'));
        this.isDesktop = this.dataset.mode === 'desktop';
        this.hoverQuery = matchMedia('(hover: hover) and (pointer: fine)');
        this.disclosures.forEach((details) => {
          const summary = details.querySelector('summary');
          summary.setAttribute('aria-expanded', String(details.open));
          details.addEventListener('toggle', () => {
            summary.setAttribute('aria-expanded', String(details.open));
            if (details.open) this.closeOthers(details);
          }, options);
          details.addEventListener('pointerenter', () => {
            if (!this.isDesktop || !this.hoverQuery.matches) return;
            clearTimeout(this.closeTimer);
            this.closeOthers(details);
            details.open = true;
          }, options);
          details.addEventListener('pointerleave', () => {
            if (!this.isDesktop || !this.hoverQuery.matches) return;
            this.closeTimer = setTimeout(() => {
              if (!details.contains(document.activeElement)) details.open = false;
            }, 160);
          }, options);
          summary.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
            event.preventDefault();
            this.closeOthers(details);
            details.open = true;
            const links = details.querySelectorAll('.WuyinNav__Panel a');
            const target = event.key === 'ArrowUp' ? links[links.length - 1] : links[0];
            target?.focus();
          }, options);
          details.addEventListener('focusout', () => {
            if (!this.isDesktop) return;
            requestAnimationFrame(() => {
              if (!details.contains(document.activeElement) && !details.matches(':hover')) details.open = false;
            });
          }, options);
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            const open = event.target.closest('details[open]');
            if (!open) return;
            event.preventDefault();
            event.stopPropagation();
            open.open = false;
            open.querySelector('summary').focus();
          }
          if (this.isDesktop && (event.key === 'ArrowRight' || event.key === 'ArrowLeft') && event.target.matches('summary')) {
            event.preventDefault();
            const summaries = this.disclosures.map((details) => details.querySelector('summary'));
            const step = event.key === 'ArrowRight' ? 1 : -1;
            summaries[(summaries.indexOf(event.target) + step + summaries.length) % summaries.length].focus();
          }
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (this.isDesktop && !this.contains(event.target)) this.closeOthers();
        }, options);
        document.addEventListener('click', (event) => {
          if (event.target.closest('[data-action="toggle-search"], [data-action="open-drawer"], [data-action="close-drawer"]')) this.closeOthers();
        }, options);
        window.addEventListener('resize', () => this.closeOthers(), options);
      }

      closeOthers(current) {
        this.disclosures.forEach((details) => {
          if (details !== current) details.open = false;
        });
      }

      disconnectedCallback() {
        clearTimeout(this.closeTimer);
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
